module.exports = __webpack_public_path__ + "img/Imagen 4.9ac5bb0e.jpg";